import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const DropIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "24", height: "24", viewBox: "0 0 24 24", className: classNames(styles.root, className) },
        React.createElement("g", { id: "vuesax_linear_drop", "data-name": "vuesax/linear/drop", transform: "translate(-172 -252)" },
            React.createElement("g", { id: "drop" },
                React.createElement("path", { id: "Vector", d: "M8.7.21a.991.991,0,0,0-1.22,0C5.58,1.66-.03,6.39,0,11.9a8.1,8.1,0,0,0,16.2.01C16.21,6.48,10.59,1.67,8.7.21Z", transform: "translate(175.91 254)", fill: "none", stroke: "currentColor", strokeWidth: "1.5" }),
                React.createElement("path", { id: "Vector-2", "data-name": "Vector", d: "M0,0H24V24H0Z", transform: "translate(172 252)", fill: "none", opacity: "0" })))));
};
export default DropIcon;
//# sourceMappingURL=DropIcon.js.map